<ng-container *ngIf="dataLoaded && gridData.length !== 0">
  <section
    edsPadding
    [edsPaddingLeft]="(isMobile$ | async) ? 'sm' : 'none'"
    [edsPaddingRight]="(isMobile$ | async) ? 'sm' : 'none'"
    edsSpacing="lg"
  >
    <!-- breadcrumb area -->
    <eds-breadcrumbs
      [items]="showBreadcrumb ? breadcrumbItems : null"
      theme="basic"
      edsPadding
      edsPaddingLeft="sm"
    >
    </eds-breadcrumbs>
    <div edsGrid>
      <div class="container" edsPadding edsPaddingTop="lg">
        <!-- Your Cart -->
        <p edsSpacing="xs" class="pre-title">
          {{ "literature.your-cart" | translate }}
        </p>
        <!-- Your Delivery Option -->
        <eds-title
          edsSpacing="xs"
          title="{{ 'literature.delivery-option' | translate }}"
          size="h1"
          theme="dark"
          [level]="1"
          *ngIf="
            !(gridData.length === hardCopyNotAvailableCount) ||
            !allDocsInCartUnableToDownload
          "
        ></eds-title>
        <eds-title
          size="h5"
          theme="basic"
          [isLight]="true"
          [level]="3"
          [title]="'literature.delivery-methods' | translate"
          *ngIf="
            !(gridData.length === hardCopyNotAvailableCount) ||
            !allDocsInCartUnableToDownload
          "
        ></eds-title>
      </div>
    </div>
  </section>

  <div
    edsGrid
    [edsSpacing]="(isHandheld$ | async) === false ? 'xxxl' : 'xxl'"
    edsPadding
    [edsPaddingLeft]="(isMobile$ | async) ? 'sm' : 'none'"
    [edsPaddingRight]="(isMobile$ | async) ? 'sm' : 'none'"
  >
    <div class="container">
      <div edsSpacing="lg">
        <eds-radio-group
          (radioChange)="updateDeliveyOption($event)"
          name="{{ 'literature.delivery-methods' | translate }}"
        >
          <eds-radio
            [id]="2"
            name="story-radiogroup"
            *ngIf="!allDocsInCartUnableToDownload"
            value="2"
            [checked]="true"
            labelName="{{ 'literature.download-title' | translate }}"
          >
          </eds-radio>
          <div
            *ngIf="!allDocsInCartUnableToDownload"
            edsPadding
            [edsPaddingLeft]="(isHandheld$ | async) ? 'md' : 'sm'"
          >
            <p
              class="small text-grey1"
              edsPadding
              [edsPaddingLeft]="(isHandheld$ | async) ? 'lg' : 'md'"
              edsPaddingTop="sm"
            >
              {{ "literature.download-subTitle" | translate }}
            </p>
          </div>
          <eds-radio
            [id]="3"
            name="story-radiogroup"
            value="3"
            labelName="{{ 'literature.email-title' | translate }}"
            *ngIf="!allDocsInCartUnableToDownload"
          >
          </eds-radio>
          <div
            edsPadding
            [edsPaddingLeft]="(isHandheld$ | async) ? 'md' : 'sm'"
            *ngIf="!allDocsInCartUnableToDownload"
          >
            <p
              class="small text-grey1"
              edsPadding
              [edsPaddingLeft]="(isHandheld$ | async) ? 'lg' : 'md'"
              edsPaddingTop="sm"
            >
              {{ "literature.email-subTitle" | translate }}
            </p>
          </div>
          <eds-radio
            *ngIf="!(gridData.length === hardCopyNotAvailableCount)"
            [id]="1"
            name="story-radiogroup"
            value="1"
            labelName="{{ 'literature.mail-title' | translate }}"
          >
          </eds-radio>
          <div
            *ngIf="!(gridData.length === hardCopyNotAvailableCount)"
            edsPadding
            [edsPaddingLeft]="(isHandheld$ | async) ? 'md' : 'sm'"
          >
            <p
              class="small text-grey1"
              edsPadding
              edsSpacing="none"
              [edsPaddingLeft]="(isHandheld$ | async) ? 'lg' : 'md'"
              edsPaddingTop="sm"
            >
              {{ "literature.mail-subTitle" | translate }}
            </p>
          </div>
        </eds-radio-group>
      </div>
      <div edsFlexbox flexDirection="column" edsSpacing="lg">
        <div
          *ngIf="deliveryOption === '3'"
          [edsSpacing]="(isHandheld$ | async) === false ? 'xs' : 'sm'"
          edsFlexbox
          flexDirection="column"
        >
          <div edsSpacing="sm">
            {{ "literature.email-address-label" | translate }}
          </div>
          <div edsSubGrid="layout-3">
            <eds-text-input
              placeholder="{{
                'literature.email-address-placeholder' | translate
              }}"
              label="{{ 'literature.email' | translate }}"
              type="type"
              required="required"
              aria-label="inputText"
              [hasHelperText]="true"
              value=""
              (inputTextChange)="checkEmail($event)"
            ></eds-text-input>
          </div>
          <p
            style="font-weight: bold; font-style: normal; color: #cb0000"
            edsSpacing="md"
            *ngIf="!isValid"
          >
            {{ "literature.email-field-error-message" | translate }}
          </p>
        </div>
      </div>
      <p edsSpacing="xs" edsPadding edsPaddingBottom="sm">
        {{ "literature.your-cart-rich-text" | translate }}
      </p>
      <div
        edsFlexbox
        [flexDirection]="(isMobile$ | async) === false ? 'row' : 'column'"
        justifyContent="space-between"
      >
        <div edsFlexbox>
          <p edsPadding edsPaddingRight="sm" edsSpacing="md">
            {{ "literature.cart-total-items" | translate }} :
            {{ gridData.length }}
          </p>
          <p class="separator"></p>
          <ng-container *ngIf="overAllQty !== 0; else overAllNA">
            <p edsPadding edsPaddingLeft="sm" edsSpacing="md">
              {{ "literature.overall-quantity" | translate }} :
              {{ overAllQty }}
            </p>
          </ng-container>
          <ng-template #overAllNA>
            <p edsPadding edsPaddingLeft="sm" edsSpacing="md">
              {{ "literature.overall-quantity" | translate }} :
              {{ "literature.NA" | translate }}
            </p>
          </ng-template>
        </div>
        <div>
          <eds-link-item
            (click)="showEmptyCartDailog($event)"
            title="{{ 'literature.empty-cart' | translate }}"
            edsSpacing="md"
          ></eds-link-item>
        </div>
      </div>

      <!-- desktop view -->
      <div *ngIf="(isHandheld$ | async) === false; else contentBlock">
        <table
          *ngIf="(isHandheld$ | async) === false; else contentBlock"
          class="table table--secondary table--overflow"
        >
          <thead class="table__thead">
            <tr class="table__tr">
              <th class="table__th">
                <span class="small">{{ "literature.item" | translate }}</span>
              </th>
              <th class="table__th text-align-left">
                <span class="small">{{
                  "literature.client-use" | translate
                }}</span>
              </th>
              <th
                *ngIf="deliveryOption === '1'"
                class="table__th text-align-left"
                style="width: 14%"
              >
                <span class="small">{{
                  "literature.quantity" | translate
                }}</span>
              </th>
              <th class="table__th text-align-left">
                <span class="small">{{ "literature.action" | translate }}</span>
              </th>
            </tr>
          </thead>
          <tbody class="table__body">
            <tr class="table__tr" *ngFor="let data of gridData">
              <td class="table__td">
                <div edsFlexbox>
                  <div>
                    <ng-container *ngIf="data.clientUse; else disableNameLink">
                      <eds-link-item
                        [title]="data.fundName"
                        [href]="getLiteratureDetailLink(data.docId)"
                      ></eds-link-item>
                    </ng-container>
                    <ng-template #disableNameLink>
                      <p class="spacing--none ag-cell-fund-name">
                        {{ data.fundName }}
                      </p>
                    </ng-template>
                    <p
                      style="font-style: normal"
                      class="small"
                      edsPadding
                      edsPaddingBottom="xs"
                      edsPaddingTop="xs"
                      *ngIf="data.mandatoryMaterialPrimary"
                    >
                      {{ mandatoryMaterialMsg }}
                      {{ data.mandatoryMaterialPrimary }}
                    </p>
                    <eds-notifications
                      *ngIf="data.clientUse === 'No'"
                      [title]="clientNotApprovedMsg"
                      [notificationType]="'warning'"
                      [inline]="true"
                      [canClose]="false"
                      [small]="true"
                    >
                    </eds-notifications>
                    <eds-notifications
                      *ngIf="data.hardCopyNotAvailable"
                      [title]="hardCopyNotAvailableTitle"
                      [notificationType]="'warning'"
                      [inline]="true"
                      [canClose]="false"
                      [small]="true"
                    >
                    </eds-notifications>
                    <div
                      *ngIf="data.mandatoryMaterialDependentMsg"
                      edsPadding
                      edsPaddingTop="sm"
                    >
                      <eds-notifications
                        [hasBorders]="true"
                        [hasBorderRadius]="true"
                        [hasShadows]="true"
                        [title]="mandatoryMaterialTitle"
                        [body]="data.mandatoryMaterialDependentMsg"
                        [notificationType]="'error'"
                        [canClose]="false"
                        [small]="true"
                      >
                      </eds-notifications>
                    </div>
                  </div>
                </div>
              </td>
              <td class="table__td table__td--middle text-align-left">
                <ng-container
                  *ngIf="!data.hardCopyNotAvailable; else notApplicableTemplate"
                >
                  {{ data.clientUse }}
                </ng-container>
              </td>
              <td
                *ngIf="deliveryOption === '1'"
                class="table__td table__td--middle text-align-left"
                style="width: 14%"
              >
                <ng-container
                  *ngIf="!data.hardCopyNotAvailable; else notApplicableTemplate"
                >
                  <ng-container
                    *ngTemplateOutlet="
                      quantityDropdown;
                      context: { dropdownData: data }
                    "
                  >
                  </ng-container>
                </ng-container>
              </td>
              <td class="table__td table__td--middle text-align-left">
                <eds-link-item
                  *ngIf="!data.mandatoryMaterialPrimary"
                  (click)="deleteDocument(data, $event)"
                  title="{{ 'literature.delete' | translate }}"
                ></eds-link-item>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #contentBlock>
        <div class="cards-mobile">
          <eds-panel
            edsSpacing="md"
            *ngFor="let data of cardViewData"
            [hasBorders]="true"
          >
            <div
              edsFlexbox
              flexDirection="column"
              edsPadding
              edsPaddingTop="lg"
              edsPaddingBottom="lg"
            >
              <eds-link-item
                *ngIf="!data.mandatoryMaterialPrimary"
                edsFlexbox
                justifyContent="flex-end"
                (click)="deleteDocument(data, $event)"
                title="{{ 'literature.delete' | translate }}"
                [hasIcon]="true"
                type="cross"
                class="text-primary"
                edsSpacing="md"
                edsPadding
                edsPaddingRight="md"
              ></eds-link-item>
              <div edsFlexbox>
                <div>
                  <ng-container *ngIf="data.client; else disableNameLink">
                    <eds-link-item
                      edsPadding
                      edsPaddingRight="md"
                      edsPaddingLeft="md"
                      [title]="data.name"
                      edsSpacing="md"
                    >
                    </eds-link-item>
                  </ng-container>
                  <ng-template #disableNameLink>
                    <p class="spacing--none ag-cell-fund-name">
                      {{ data.name }}
                    </p>
                  </ng-template>
                  <p
                    edsPadding
                    edsPaddingRight="md"
                    edsPaddingLeft="md"
                    style="font-style: normal"
                    class="small"
                    *ngIf="data.mandatoryMaterialPrimary"
                  >
                    {{ mandatoryMaterialMsg }}
                    {{ data.mandatoryMaterialPrimary }}
                  </p>
                  <div *ngIf="data.client === 'No'">
                    <eds-notifications
                      [title]="clientNotApprovedMsg"
                      [notificationType]="'warning'"
                      [inline]="true"
                      [canClose]="false"
                      [small]="true"
                    >
                    </eds-notifications>
                  </div>
                  <div *ngIf="data.hardCopyNotAvailable">
                    <eds-notifications
                      [title]="hardCopyNotAvailableTitle"
                      [notificationType]="'warning'"
                      [inline]="true"
                      [canClose]="false"
                      [small]="true"
                    >
                    </eds-notifications>
                  </div>
                  <div
                    *ngIf="data.mandatoryMaterialDependentMsg"
                    edsPadding
                    edsPaddingTop="sm"
                  >
                    <eds-notifications
                      [hasBorders]="true"
                      [hasBorderRadius]="true"
                      [hasShadows]="true"
                      [title]="mandatoryMaterialTitle"
                      [body]="data.mandatoryMaterialDependentMsg"
                      [notificationType]="'error'"
                      [canClose]="false"
                      [small]="true"
                    >
                    </eds-notifications>
                  </div>
                </div>
              </div>
              <eds-panel theme="grey" [hasPadding]="true">
                <eds-info-item
                  edsSpacing="xs"
                  *ngFor="let info of data.cardView"
                  [info]="info"
                >
                </eds-info-item>
                <eds-info-item
                  *ngIf="deliveryOption === '1'"
                  [info]="data.itemCardView"
                >
                  <div edsFlexbox justifyContent="flex-end">
                    <ng-container
                      *ngIf="
                        !data.hardCopyNotAvailable;
                        else notApplicableTemplate
                      "
                    >
                      <ng-container
                        *ngTemplateOutlet="
                          quantityDropdown;
                          context: { dropdownData: data }
                        "
                      >
                      </ng-container>
                    </ng-container>
                  </div>
                </eds-info-item>
              </eds-panel>
            </div>
          </eds-panel>
        </div>
      </ng-template>
      <div edsFlexbox edsPadding edsPaddingTop="lg">
        <div edsPadding edsPaddingRight="sm">
          <button
            edsButton="secondary"
            size="normal"
            [noMargin]="true"
            (click)="goToLiterature()"
          >
            <span>{{ "literature.lit-continue-browse" | translate }}</span>
          </button>
        </div>
        <button
          edsButton="primary"
          size="normal"
          data-analytics-no-event="true"
          [noMargin]="true"
          [disabled]="
            (deliveryOption === '1' &&
              gridData.length === hardCopyNotAvailableCount) ||
            (deliveryOption === '3' && isDisabled)
          "
          (click)="handleDelivery()"
        >
          <span>{{ btnLabel2 }}</span>
          <eds-icon
            *ngIf="deliveryOption === '2'"
            type="download"
            size="small"
            edsPadding
            edsPaddingLeft="xs"
          ></eds-icon>
        </button>
      </div>
    </div>
  </div>
  <ng-template #notApplicableTemplate>
    {{ "literature.NA" | translate }}
  </ng-template>
  <ng-template let-data="dropdownData" #quantityDropdown>
    <eds-dropdown
      ariaLabel="Dropdown"
      [dropdownId]="'drop-down'"
      name="drop-down"
      [items]="dropdownItems"
      (dropdownChange)="updateQuantity(data.docId, $event)"
      [preselectedValue]="
        getReorderQuantity(data.reOrderQty)
          ? getReorderQuantity(data.reOrderQty)
          : dropdownItems[data.quantity - 1]
      "
      label="{{ 'literature.qty' | translate }}"
    ></eds-dropdown>
  </ng-template>
</ng-container>

<ft-literature-dialog
  [dialogId]="modalIdValue"
  [modalIdEnum]="'cartModal'"
  [dynamicBodyTextToAppend]="dynamicBodyTextToAppend"
  [dialogMandatoryMaterials]="dialogMandatoryMaterials"
  (dialog)="closeModal($event)"
  (emptyCart)="emptyCart($event)"
  (modalClosedInternally)="handleEdsCloseEvent($event)"
  (removeMandatoryItems)="removeMandatoryMaterial()"
  (modalClose)="closeModal('cartModal')"
  data-analytics-no-event="true"
></ft-literature-dialog>

<ng-container *ngIf="dataLoaded && gridData.length === 0">
  <section
    edsPadding
    [edsPaddingLeft]="(isMobile$ | async) ? 'sm' : 'none'"
    [edsPaddingRight]="(isMobile$ | async) ? 'sm' : 'none'"
    edsSpacing="lg"
  >
    <div edsGrid>
      <div class="container" edsPadding edsPaddingTop="lg">
        <!-- Your Cart -->
        <p edsSpacing="xs" class="pre-title">
          {{ "literature.your-cart" | translate }}
        </p>
        <p edsSpacing="xs">
          {{ "literature.no-items" | translate }}
          <a
            (click)="goToLiterature()"
            [ngStyle]="{
              cursor: 'pointer'
            }"
          >
            <span>{{ "literature.literature" | translate }}</span>
          </a>
          {{ "literature.select-materials" | translate }}
        </p>
      </div>
    </div>
  </section>
</ng-container>

<ng-container *ngIf="!dataLoaded">
  <ngx-skeleton-loader
    edsCol
    [count]="10"
    animation="pulse"
    [theme]="{
      'background-color': '#e8e8e8',
      'border-radius': '0',
      height: 'var(--space-xxl)'
    }"
  ></ngx-skeleton-loader>
</ng-container>
